import { render, staticRenderFns } from "./QNAManagement.vue?vue&type=template&id=5ea3d13f&scoped=true"
import script from "./QNAManagement.vue?vue&type=script&lang=js"
export * from "./QNAManagement.vue?vue&type=script&lang=js"
import style0 from "./QNAManagement.vue?vue&type=style&index=0&id=5ea3d13f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea3d13f",
  null
  
)

export default component.exports